import React from 'react';
import MediaQuery from 'react-responsive';
import ContentLoader from 'react-content-loader';

import './styles.css';

const ProfileContentLoader = () => (
  <>
    <MediaQuery query="(min-width: 768px)">
      <div className="profile-content-loader">
        <div className="profile-content-loader--container">
          <ContentLoader
            height={300}
            width={1200}
            speed={2}
            primaryColor="#f3f3f3"
            secondaryColor="#ecebeb"
          >
            <circle cx="85" cy="80" r="80" />
            <rect x="226" y="0" rx="3" ry="3" width="35%" height="20" />
            <rect x="226" y="40" rx="3" ry="3" width="40%" height="20" />
            <rect x="226" y="80" rx="3" ry="3" width="35%" height="20" />
            <rect x="226" y="130" rx="3" ry="3" width="200" height="20" />
            <rect x="226" y="180" rx="3" ry="3" width="45%" height="20" />
            <rect x="226" y="220" rx="3" ry="3" width="40%" height="20" />

            <rect x="226" y="260" rx="3" ry="3" width="60%" height="20" />
            <rect x="226" y="300" rx="3" ry="3" width="60%" height="20" />
          </ContentLoader>
        </div>
      </div>
    </MediaQuery>

    <MediaQuery query="(max-width: 767px)">
      <div className="profile-content-loader">
        <div className="profile-content-loader--container">
          <ContentLoader
            height={360}
            width={320}
            speed={2}
            primaryColor="#f3f3f3"
            secondaryColor="#ecebeb"
            style={{ maxHeight: '500px', height: 'auto' }}
          >
            <rect x="50" y="206" rx="0" ry="0" width="225" height="28" />
            <rect x="90" y="250" rx="0" ry="0" width="135" height="20" />
            <rect x="50" y="290" rx="0" ry="0" width="102" height="20" />
            <rect x="170" y="290" rx="0" ry="0" width="102" height="20" />
            <circle cx="158" cy="102" r="80" />
            <rect x="50" y="333" rx="0" ry="0" width="220" height="20" />
          </ContentLoader>
        </div>
      </div>
    </MediaQuery>
  </>
);

export default ProfileContentLoader;
